export const ALL_CONTENT_CATEGORIES = "/content_category/list";
export const ADD_CONTENT_CATEGORY = "/content_category/add";
export const UPDATE_CONTENT_CATEGORY = "/content_category/update";
export const DELETE_CONTENT_CATEGORY = "/content_category/delete";
export const CONTENT_CATEGORY_BY_ID = "/content_category/detail";
